// import {newSpecPage} from '@stencil/core/testing';
import {SallaPriceRange} from '../salla-price-range';

/*
TODO: Find a better way to test the component, it's not testable without passing the props and
 the props can not be passed as an object, there has to be JSON.parsing
 */
describe('salla-price-range', () => {
  it("should build", () => {
    expect(new SallaPriceRange()).toBeTruthy();
  })

  // describe("Rendering", () => {
  //   let page;

  //   it.skip("should be able to render component in dom", async () => {
  //     page = await newSpecPage({
  //       components: [SallaPriceRange],
  //       html: `<salla-price-range filters-data='{"price":{"max":1234,"min":432}}'
  //                                    option='{"label":"string","key":"categories","type":"range","min":100,"max":10000,"values":[]}'></salla-price-range>`
  //     })
  //     // let priceRangeComponent = await page.doc.querySelector("salla-price-range")
  //   })
  // })
});
